import React, { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";
import { render } from "react-dom";
import Image from "next/image";
import Link from "next/link";

import HeaderNav from "../../includes/HeaderNav";
import Footer from "../../includes/Footer";
import BookingSec from "./BookingCTA";
import Partners from "./Partners";
import EardCTA from "./kyna/EardCTA";

import MentalHealthSession from "../../../public/assets/img/icons/mental-health-icon.svg";
import TrainingMentalHealth from "../../../public/assets/img/icons/awareness-icon.svg";
import OrientationProgram from "../../../public/assets/img/icons/orientation-icon.svg";
import MultimediaProgram from "../../../public/assets/img/icons/multimedia-icon.svg";

//SLIDER
import IEASlider from "./IEASlider";
import YLEPSlider from "./YLEPSlider";
import CBMHPSlider from "./CBMHPSlider";
import ResearchSlider from "./ResearchSlider";
import MembershipVolunteerSlider from "./MembershipVolunteerSlider";

// PARTNER LOGOS
import DOHLogo from "../../../public/assets/img/partner-logos/doh.png";
import JohnsonLogo from "../../../public/assets/img/partner-logos/johnson-and-johnson-logo.png";
import Give2Asia from "../../../public/assets/img/partner-logos/give2asia.png";
import PocariLogo from "../../../public/assets/img/partner-logos/pocari-sweat.png";
import TaguigLogo from "../../../public/assets/img/partner-logos/city-of-taguig.png";
import NavotasLogo from "../../../public/assets/img/partner-logos/city-of-navotas.png";
import QClogo from "../../../public/assets/img/partner-logos/quezon-city.png";
import MarikinaLogo from "../../../public/assets/img/partner-logos/marikina-city.png";
import DOLELogo from "../../../public/assets/img/partner-logos/dole.png";
import DEPEDLogo from "../../../public/assets/img/partner-logos/deped.png";
import PHOccupationalTherapistsLogo from "../../../public/assets/img/partner-logos/philippine-academy-of-occupational-therapists.png";
import PHGuidanceLogo from "../../../public/assets/img/partner-logos/philippine-guidance-counseling-assoc.png";
import YouthForMentalLogo from "../../../public/assets/img/partner-logos/youth-for-mental-health.png";
import NoBullyLogo from "../../../public/assets/img/partner-logos/no-bully.png";
import PowerOfZeroLogo from "../../../public/assets/img/partner-logos/power-of-zero.png";
import UNFPALogo from "../../../public/assets/img/partner-logos/unfpa.png";
import MeralcoLogo from "../../../public/assets/img/partner-logos/meralco.png";
import OrganicIntelligenceLogo from "../../../public/assets/img/partner-logos/organic-intelligence.png";
import SunLifeLogo from "../../../public/assets/img/partner-logos/sunlife-logo.png";
import ZaloraLogo from "../../../public/assets/img/partner-logos/zalora.png";
import WilservLogo from "../../../public/assets/img/partner-logos/wilserv.png";
import OtsukaLogo from "../../../public/assets/img/partner-logos/otsuka.png";
import XolveMedLogo from "../../../public/assets/img/partner-logos/xolvemed.png";

const Eard = () => {
  return (
    <>
      {/* MAIN NAVIGATION */}
      <HeaderNav />

      {/* EARD HEADER */}
      <section className="lg:pt-[100px] pt-[85px]">
        <div className="bg-[url('/assets/img/ead-header-image-3.jpg')] bg-top bg-cover bg-no-repeat lg:min-h-[550px] sm:min-h-[350px] min-h-[200px]"></div>
        <div class="relative bg-white">
          <div class="absolute bottom-0 left-0 w-full overflow-hidden leading-[0]">
            <svg
              class="relative block w-full h-[60px]"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1440 120"
              preserveAspectRatio="none"
            >
              <path
                d="M0,0 C480,60 960,60 1440,0 L1440,120 L0,120 Z"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
        </div>
        <div className="max-w-screen-2xl mx-auto sm:px-10 px-8 lg:mt-16 md:mt-10 mt-5">
          <div className="max-w-4xl mx-auto">
            <h1 className="max-w-2xl lg:text-5xl sm:text-4xl text-3xl !leading-tight">
              Education and Advocacy Department
            </h1>
            <p className="text-justify sm:text-lg text-base leading-relaxed border-t border-t-gray-300 pt-10 mb-4">
              EAD is the primary program of the Association that strives to
              strengthen its pursuit to promote mental health and prevent mental
              disorders through increasing public awareness campaigns and
              activities.
            </p>
          </div>
        </div>
      </section>

      {/* EAD BODY */}
      <section className="max-w-screen-2xl mx-auto mt-10 py-14 sm:px-10 px-8">
        <div className="grid grid-cols-12">
          <div className="col-span-12">
            <p className="md:text-2xl text-xl mb-14">
              EAD Programs are the following:
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center pt-0 pb-12">
          <div className="col-span-1">
            <h2 className="md:text-3xl text-2xl text-blue font-semibold">
              I. Information and Education Activities
            </h2>
            <p className="text-justify sm:text-lg text-base">
              Information and Education Activities (IEA) is the fundamental and
              core advocacy arm of the EAD in promoting mental health through
              orientations, institutional visits, mental health learning
              sessions, multimedia efforts, collaborations, and partnerships.
              IEA is dedicated to the promotion of PMHA services as a whole and
              ensuring the widespread campaign of the Association's programs
              through a holistic and comprehensive approach. IEA also spearheads
              the celebration of National Mental Health Week every second week
              of October, and World Mental Health Day every October 10.
            </p>
          </div>
          <div className="col-span-1">
            <IEASlider />
          </div>
        </div>

        <div className="grid xl:grid-cols-4 lg:grid-cols-2 grid-cols-1 gap-6 pb-20">
          <div className="col-span-1">
            <div className="bg-sky-100 py-8 px-7 rounded-2xl h-full">
              <div className="text-center mb-0">
                <div className="bg-white rounded-full max-w-[100px] h-auto mx-auto mb-5 flex items-center p-3">
                  <Image
                    src={MentalHealthSession}
                    alt="Mental Health Learning Sessions"
                  />
                </div>
                <h3 className="text-lg leading-snug lg:mb-0 mb-5 xl:min-h-[100px] lg:min-h-[70px] min-h-full">
                  Mental Health Learning Sessions
                </h3>
              </div>
              <p className="text-justify mb-3">
                Lectures and/or Workshops on Mental Health Topics for companies,
                organizations, schools and other institutions
              </p>
              <p className="text-justify text-sm">
                e.g. Caring for Your Mental Health, Applications of the MH Act
                (RA 11036) in the Workplace, Understanding and Managing
                Depression and Anxiety, Stress Management, Arts for Wellness,
                Mindfulness, Enhancing Family Relationships, Psychological First
                Aid, etc.
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="bg-sky-100 py-8 px-7 rounded-2xl h-full">
              <div className="text-center mb-0">
                <div className="bg-white rounded-full max-w-[100px] h-auto mx-auto mb-5 flex items-center p-3">
                  <Image
                    src={TrainingMentalHealth}
                    alt="Training in the Creation of a Workplace Mental Health Program"
                  />
                </div>
                <h3 className="text-lg leading-snug lg:mb-0 mb-5 xl:min-h-[100px] lg:min-h-[70px] min-h-full">
                  Training in the Creation of a Workplace Mental Health Program
                </h3>
              </div>
              <p className="text-justify">
                Human Resource and Occupational Safety Officers will be provided
                lectures and workshop that will help them evaluate the needs of
                their companies and create a Workplace Mental Health Program.
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="bg-sky-100 py-8 px-7 rounded-2xl h-full">
              <div className="text-center mb-0">
                <div className="bg-white rounded-full max-w-[100px] h-auto mx-auto mb-5 flex items-center p-3">
                  <Image
                    src={OrientationProgram}
                    alt="Orientation on PMHA Programs and Services"
                  />
                </div>
                <h3 className="text-lg leading-snug lg:mb-0 mb-5 xl:min-h-[100px] lg:min-h-[70px] min-h-full">
                  Orientation on PMHA Programs and Services
                </h3>
              </div>
              <p className="text-justify">
                PMHA advocates mental health through orientations, institutional
                visits, and booth set-ups where various individuals and
                organizations, and those interested to know more about PMHA,
                upon request, are able to take a glimpse of the Organization’s
                programs and services.
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="bg-sky-100 py-8 px-7 rounded-2xl h-full">
              <div className="text-center mb-0">
                <div className="bg-white rounded-full max-w-[100px] h-auto mx-auto mb-5 flex items-center p-3">
                  <Image src={MultimediaProgram} alt="Multimedia" />
                </div>
                <h3 className="text-lg leading-snug lg:mb-0 mb-5 xl:min-h-[100px] lg:min-h-[70px] min-h-full">
                  Multimedia
                </h3>
              </div>
              <p className="text-justify">
                PMHA recognizes the role that media play in further advancing
                the campaign and promotion of mental health amongst the general
                public. The Association believes in the power of media in
                shaping consciousness and eradicating stigma to a larger group
                of people and networks about mental health concepts and mental
                disorders. From radio and TV partners (Broadcast), up to the
                comprehensive print materials such as mental health brochures
                and leaflets (Print), the Organization now takes on a higher
                level of campaigning by incorporating the power of social media
                in mental health advocacy (Digital).
              </p>
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center py-12">
          <div className="col-span-1 lg:block hidden">
            <YLEPSlider />
          </div>
          <div className="col-span-1">
            <h2 className="md:text-3xl text-2xl text-blue font-semibold">
              II. Youth Life Enrichment Program
            </h2>
            <p className="text-justify sm:text-lg text-base">
              The Youth Life Enrichment Program (YLEP) is a preventive mental
              health program for the youth. It aims to enrich their mental
              health literacy and empower them to become PMHA’s allies. They are
              trained to become mental health advocates in their families and
              respective school communities through participation in
              psycho-education and capacity-building activities. Likewise, the
              parents and teachers of students were also involved in the program
              for they are critical partners in enabling and helping the youth
              develop psychosocial skills to address mental health challenges
              during this current health crisis.
            </p>
          </div>
          <div className="col-span-1 lg:hidden block">
            <YLEPSlider />
          </div>
        </div>

        <div className="grid lg:grid-cols-3 grid-cols-1 gap-6 pb-12">
          <div className="col-span-1">
            <div className="bg-sky-100 md:py-12 py-8 md:px-12 px-6 rounded-2xl h-full">
              <h3 className="text-lg">
                Lusog Isip ng Kabataan Intermediate Division (LINKid)
              </h3>
              <p className="mb-3">
                School-based mental health club in the Primary / Elementary
                Division (from Grade 1 – Grade 6)
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="bg-sky-100 md:py-12 py-8 md:px-12 px-6 rounded-2xl h-full">
              <h3 className="text-lg lg:max-w-[250px] max-w-full">
                Lusog Isip ng Kabataan (LINK) Club
              </h3>
              <p>
                School-based mental health club in the Secondary or High School
                Division (from Grade 7-Grade 10)
              </p>
            </div>
          </div>
          <div className="col-span-1">
            <div className="bg-sky-100 md:py-12 py-8 md:px-12 px-6 rounded-2xl h-full">
              <h3 className="text-lg">
                Psychological Society Association for Mental Health (PSAMH)
              </h3>
              <p>
                School-based mental health clubs and association of College
                Psychology Organizations in Metro Manila and the nearby
                provinces.
              </p>
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center py-12">
          <div className="col-span-1">
            <h2 className="md:text-3xl text-2xl text-blue font-semibold">
              III. Community Based Mental Health Program
            </h2>
            <p className="text-justify sm:text-lg text-base">
              The Community-Based Mental Health Program (CBMHP) primarily aims
              to promote and strengthen mental health advocacy at the grassroots
              level by training health workers and health center physicians, to
              plan, coordinate and implement mental health programs in the
              community. It enables the health workers to become equipped with
              necessary skills and competencies to educate their communities
              about mental health, provide initial psychosocial support and make
              referrals of at-risk community members.
            </p>
          </div>
          <div className="col-span-1">
            <CBMHPSlider />
          </div>
        </div>

        <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center py-12 hidden">
          <div className="col-span-1 lg:block hidden">
            <ResearchSlider />
          </div>
          <div className="col-span-1">
            <h2 className="md:text-3xl text-2xl text-blue font-semibold">
              IV. Research Program
            </h2>
            <p className="text-justify sm:text-lg text-base">
              The Research Program functions to help establish evidence-based
              and empirically-supported programs and services within the
              Association, at the same time, contribute in advancing
              mental-health-centered studies apropos to the Filipino setting.
              Collectively, EAD's Research Program aims to make invaluable
              contributions for both theoretical and pragmatic progress in
              empirically-supported or research-informed promotion and practice
              of mental health initiatives within the Filipino context.
              Essentially, compassionate and responsible mental health efforts
              through committed scientific rigor are operative in the overall
              role of EAD's Research Program.
            </p>
          </div>
          <div className="col-span-1 lg:hidden block">
            <ResearchSlider />
          </div>
        </div>

        <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center py-12">
          <div className="col-span-1">
            <MembershipVolunteerSlider />
          </div>
          <div className="col-span-1">
            <h2 className="md:text-3xl text-2xl text-blue font-semibold">
              IV. Membership and Volunteer Program
            </h2>
            <p className="text-justify sm:text-lg text-base">
              The Membership and Volunteer Program (MVP) aims to keep members
              engaged in dedicating their time, talent and treasure in different
              activities, which in return expands their network, gives them an
              avenue to share their expertise, and strengthens their ties with
              the community. The PMHA Membership fees help sustain the mental
              health services for indigent service users and in the
              implementation of PMHA’s programs and services. On the other hand,
              the Volunteer Program continues to encourage professionals to take
              part in the Association’s advocacy. To keep the volunteers engaged
              and encourage them to enhance their skills, Orientations,
              Training, Volunteer Onboarding, Monthly Kumustahan Sessions, and
              Monthly Learning Sessions are consistently conducted.
            </p>
          </div>
        </div>
      </section>

      {/* POWER OF ZERO BODY */}
      <section className="py-14 sm:px-10 px-8 bg-[url('/assets/img/eard/power-of-zero/power-of-zero-banner.jpg')] bg-cover bg-center bg-no-repeat relative">
        <div className="max-w-[980px] mx-auto relative z-20 py-5">
          <div className="grid grid-cols-1">
            <p className="text-white md:text-xl text-lg text-center font-semibold uppercase tracking-wider">
              EAD Special Projects
            </p>
            <h2 className="text-white md:text-5xl text-4xl  text-center font-semibold">
              Power of Zero
            </h2>
            <p className="text-white text-center sm:text-xl text-lg mb-8">
              The Power of Zero is an initiative that promotes the safety and
              welfare of children in today's increasingly digital world. Its
              focus is helping cultivating healthy digital habits among
              children, while enabling awareness among parents, and equip them
              with skills and resources to ensure that children are navigating
              the digital landscape safely.
            </p>
            <Link href="/power-of-zero">
              <a className="btn btn-secondary max-w-[200px] mx-auto rounded-full">
                Find out more
              </a>
            </Link>
          </div>
        </div>
        <div className="bg-blue opacity-75 absolute top-0 left-0 right-0 w-full h-full z-10"></div>
      </section>

      {/* PARTNERS AND LINKAGES */}
      <section className="max-w-screen-2xl mx-auto py-20 sm:px-10 px-8">
        <h2 className="lg:text-4xl text-3xl text-center mb-10">
          Partnerships and Linkages
        </h2>

        <div className="grid xl:grid-cols-8 lg:grid-cols-6 md:grid-cols-5 sm:grid-cols-4 grid-cols-3 lg:gap-7 gap-5 mb-5">
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={DOHLogo} alt="DOH" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={JohnsonLogo} alt="JohnsonLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={Give2Asia} alt="NULogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={PocariLogo} alt="Pocari Sweat" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={TaguigLogo} alt="City of Taguig" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={NavotasLogo} alt="City of Navotas" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={QClogo} alt="Quezon City" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={MarikinaLogo} alt="Marikina City" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={DOLELogo} alt="DOLE" />
            </div>
          </div>

          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={DEPEDLogo} alt="DEPED" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image
                src={PHOccupationalTherapistsLogo}
                alt="Philippine Academy of Occupational Therapists, Inc."
              />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image
                src={PHGuidanceLogo}
                alt="Philippine Guidance and Counseling Association, Inc."
              />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={YouthForMentalLogo} alt="Youth for Mental Health" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={NoBullyLogo} alt="No Bully" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={PowerOfZeroLogo} alt="Power of Zero" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={UNFPALogo} alt="UNFPA" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={MeralcoLogo} alt="Meralco" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={OrganicIntelligenceLogo} alt="Organic Intelligence" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={SunLifeLogo} alt="Sun Life" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={ZaloraLogo} alt="Zalora" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={WilservLogo} alt="Wilserv" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={OtsukaLogo} alt="Otsuka" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={XolveMedLogo} alt="XolveMed Pharma Inc." />
            </div>
          </div>
        </div>
      </section>

      {/* Booking CTA */}
      <EardCTA />

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Eard;
